export function toUserListItem(user) {
  return {
    label: user,
    value: user.id,
  }
}

export function isNeedToShowListItemIcons({
  Icons,
  isActive,
  isArchived,
  isMulti,
  userStatus,
}) {
  return (
    Icons &&
    (isArchived || (isActive && !isMulti) || Number.isFinite(userStatus))
  )
}
